import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ObserversModule} from "@angular/cdk/observers";
import { JdSpinComponent } from './spin.component';

@NgModule({
  imports: [
    CommonModule,
    ObserversModule
  ],
  declarations: [JdSpinComponent],
  exports: [JdSpinComponent]
})
export class JdSpinModule { }
